<template>
    <div>
        <base-button-flat
            @click="showSaveModal"
            variant="secondary"
            class="rounded-none lg:rounded-sm border-0 lg:border w-full h-12 lg:h-16 text-sm sm:text-base tracking-widest md:leading-4"
        >
            {{ $t('SAVE_EXIT') }}
        </base-button-flat>

        <base-modal-confirm
            @modalClose="showModal = false"
            @confirmAndExit="saveAndExit"
            :show-modal="showModal"
            :modal-heading="$t('DONE_FOR_NOW')"
            :modal-copy="$t('WEVE_GOT_YOU')"
            :cta-copy="$t('SAVE')"
        />
    </div>
</template>

<script>
    import BaseButtonFlat from './BaseButtonFlat.vue';
    import BaseModalConfirm from './BaseModalConfirm.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonFlat,
            BaseModalConfirm,
        },

        data() {
            return {
                showModal: false,
            };
        },

        methods: {
            showSaveModal() {
                this.showModal = true;
            },

            saveAndExit() {
                // If selections have been made, save as unique design
                // Else, return user to PDP

                this.customizerStore.saveAndExit();

                this.showModal = false;
            },
        },
    };
</script>
